module.exports = __webpack_public_path__ + "img/ekyc-ibank-guide-01.4084bea9.png";